<form class="f-col blank-form">
  <div class="section-heading">
    <h2 class="h2-heading">
      Flight promo code management
      <div class="dot">.</div>
      <span class="optional">Optional</span>
    </h2>
  </div>

  <!-- <app-cam-empty-state></app-cam-empty-state> -->

  <div class="section-content">
    <div class="inner-contentsection">
      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Title</mat-label>
            <input matInput />
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually">
          <div class="f-col">
            <div class="add-text-input">Add Supplier</div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Select Code</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix >{{ branchSelect.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            <mat-select #branchSelect>
              <mat-option> Option 1 </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="f-col">
          <mat-form-field>
            <mat-label>Code Title</mat-label>
            <input matInput />
          </mat-form-field>
        </div>
      </div>

      <div class="f-row validation-col">
        <label class="mat-label">Apply at:</label>
        <div class="f-row mat-check-group">
          <mat-checkbox class="checkbox-wrapper">Search</mat-checkbox>
          <mat-checkbox class="checkbox-wrapper">Reprice</mat-checkbox>
          <mat-checkbox class="checkbox-wrapper">PNR Creation</mat-checkbox>
          <mat-checkbox class="checkbox-wrapper">Ticketing</mat-checkbox>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Sale Valid From</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
            <input matInput />
          </mat-form-field>
        </div>
        <div class="f-col">
          <mat-form-field>
            <mat-label>Sale Valid Till</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
            <input matInput />
          </mat-form-field>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Outbound Valid From</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
            <input matInput />
          </mat-form-field>
        </div>
        <div class="f-col">
          <mat-form-field>
            <mat-label>Outbound Valid Till</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
            <input matInput />
          </mat-form-field>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Inbound Valid From</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
            <input matInput />
          </mat-form-field>
        </div>
        <div class="f-col">
          <mat-form-field>
            <mat-label>Inbound Valid Till</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
            <input matInput />
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Select Airline</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect1.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            <mat-select #branchSelect1>
              <mat-option> Option 1 </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Select Cabin</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect2.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            <mat-select #branchSelect2>
              <mat-option> Option 1 </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually">
          <div class="f-col">
            <div class="add-text-input">Add Booking Class</div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Select Origin</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect3.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            <mat-select #branchSelect3>
              <mat-option> Option 1 </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually">
          <div class="f-col">
            <div class="add-text-input">Add Origin</div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Select Destination</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect4.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            <mat-select #branchSelect4>
              <mat-option> Option 1 </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually">
          <div class="f-col">
            <div class="add-text-input">Add Destination</div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>Select Journey Type</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect5.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            <mat-select #branchSelect5>
              <mat-option> Option 1 </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually">
          <div class="f-col">
            <div class="add-text-input">Add Fare Basis Code</div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually fill-manually-pills">
          <div class="f-col">
            <div class="add-text-input">Add Business Unit</div>
            <div class="f-row pills-rows">
              <label class="pill-chip selected">
                <span>Air Asia domestic</span>
                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
              </label>

              <label class="pill-chip selected">
                <span>Akasa Retail</span>
                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
              </label>
            </div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row">
        <div class="fill-manually">
          <div class="f-col">
            <div class="add-text-input">Add office location</div>
          </div>
          <span>
            <mat-icon fontSet="material-symbols-outlined">add_circle</mat-icon>
          </span>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col">
            <label class="mat-label">Travel Type:</label>
            <mat-radio-group aria-label="Select an option">
              <mat-radio-button selected>Business</mat-radio-button>
              <mat-radio-button>Personal</mat-radio-button>
              <mat-radio-button>Both</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col">
            <label class="mat-label">Ancillary Benefits:</label>
            <div class="f-row mat-check-group">
              <mat-checkbox class="checkbox-wrapper">Free Meal</mat-checkbox>
              <mat-checkbox class="checkbox-wrapper"
                >Free Seat Selection</mat-checkbox
              >
              <mat-checkbox class="checkbox-wrapper"
                >No Charges for Cancellation</mat-checkbox
              >
              <mat-checkbox class="checkbox-wrapper"
                >Extra Baggage</mat-checkbox
              >
              <mat-checkbox class="checkbox-wrapper"
                >No Changes for first re-schedule</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col">
            <label class="mat-label">Sales Channel:</label>
            <div class="f-row mat-check-group">
              <mat-checkbox class="checkbox-wrapper"
                >Corporate SBT</mat-checkbox
              >
              <mat-checkbox class="checkbox-wrapper"
                >Point of Sale - Corporate(BOCA)</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col">
            <label class="mat-label">Status:</label>
            <mat-radio-group aria-label="Select an option">
              <mat-radio-button selected>Active</mat-radio-button>
              <mat-radio-button>Inactive</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="inner-action">
      <button mat-button class="button--secondary-small">Cancel</button>
      <button mat-button class="button--primary-small">Save</button>
    </div>
  </div>
</form>
